import {Component} from 'substance'

class PluginListItem extends Component {

    render($$) {
        const {plugin, active, added, overridden, selected} = this.props

        const item = $$('div').append(
            $$('div').addClass('pluginlist__item-info').append(
                [
                    $$('strong').append(plugin.name),
                    $$('em').append(plugin.id || '')
                ]
            )
        )
            .ref('itemWrapper')
            .addClass('pluginlist__item')
            .on('click', this.props.onClick)
            .on('dragenter', this._dragEnter)
            .on('dragleave', this._dragLeave)
            .on('dragover', this._dragOver)
            .on('dragstart', this._dragStart)
            .on('dragend', this._dragEnd)

        if (active === true) {
            if (added) {
                item.append(this._renderItemActionDelete($$, plugin))
                    .addClass('edited added')
            }
            else if (overridden) {
                item.append(this._renderItemActionRemove($$, plugin))
                    .addClass('edited')
            }
            else {
                item.append(this._renderItemActionRemove($$, plugin))
                    .addClass('original')
            }

            // Draggable plugin need id
            item.attr({
                'draggable': true,
                'id': plugin.id
            })

        } else {
            // Deleted are always furthest down, not draggable
            item.append(this._renderItemActionAdd($$, plugin))
            item.addClass('edited removed')
        }

        if (selected) {
            item.addClass('devtool_selected_plugin')
        }

        return item
    }


    /**
     * @private
     */
    _dragEnter(e) {
        this.refs.itemWrapper.addClass('drag-over')
    }

    /**
     * @private
     */
    _dragLeave(e) {
        this.refs.itemWrapper.removeClass('drag-over')
            .removeClass('add-above')
            .removeClass('add-below')
    }

    /**
     * @param e
     * @private
     */
    _dragOver(e) {
        e.preventDefault()
        e.stopPropagation()

        e.dataTransfer.dropEffect = e.target.getAttribute('data-drop-effect')

        const aboveOrBelow = e.offsetY / e.target.offsetHeight
        const itemWrap = this.refs.itemWrapper

        if (itemWrap.hasClass('add-below') && aboveOrBelow < 0.5) {
            itemWrap.removeClass('add-below').addClass('add-above')
        } else if (itemWrap.hasClass('add-above') && aboveOrBelow > 0.5) {
            itemWrap.addClass('add-below').removeClass('add-above')
        } else if (!itemWrap.hasClass('add-above') && !itemWrap.hasClass('add-below')) {
            itemWrap.addClass(aboveOrBelow <= 0.5 ? 'add-above' : 'add-below')
        }
    }

    /**
     * @param e
     * @private
     */
    _dragStart(e) {
        e.stopPropagation()
        e.dataTransfer.setData('text/plain', this.props.plugin ? this.props.plugin.id : 'cool-beans')

        this.props.onDragStart(e, this.props.plugin)

        // Preserve style of dragged element, but style element still in DOM
        setTimeout(() => this.refs.itemWrapper.addClass('dragging'))
    }

    /**
     * @param e
     * @private
     */
    _dragEnd(e) {
        e.preventDefault()
        e.stopPropagation()

        this.props.dragEnd(e)
        this.refs.itemWrapper.removeClass('dragging')
    }


    /**
     * @param $$
     * @param plugin
     * @private
     */
    _renderItemActionRemove($$, plugin) {
        return $$('i')
            .attr({title: 'Remove this plugin from current configuration'})
            .addClass('fa fa-minus')
            .on('click', (evt) => {
                return this.props.onRemoved(evt, plugin)
            })
    }

    /**
     * @param $$
     * @param plugin
     * @private
     */
    _renderItemActionDelete($$, plugin) {
        return $$('i')
            .attr({title: 'Delete this added plugin completely'})
            .addClass('fa fa-times')
            .on('click', (evt) => {
                return this.props.onRemoved(evt, plugin)
            })
    }

    /**
     * @param $$
     * @param plugin
     * @private
     */
    _renderItemActionAdd($$, plugin) {
        return $$('i')
            .attr({title: 'Add this to current configuration again'})
            .addClass('fa fa-plus')
            .on('click', (evt) => {
                return this.props.onAdded(plugin)
            })
    }

}

export default PluginListItem
